export const CACHE_EXPIRY_MESSAGEMETADATA = 14400000; // expiry in ms - 4hrs
export const CACHE_EXPIRY_USERGOVERNANCERULES = 14400000; // expiry in ms - 4hrs
export const CACHE_EXPIRY_CAMPAIGNCONTENT = 14400000; // expiry in ms - 4hrs
export const CACHE_EXPIRY_DYNAMICSETTINGS = 14400000; // expiry in ms - 4hrs
export const CACHE_EXPIRY_LOGLEVELSETTINGS = 14400000; // expiry in ms - 4hrs
export const CACHE_EXPIRY_USERFACTS = 86400000; // expiry in ms - 24hrs

export const TMS_CAMPAIGNMETADATAAGGREGATOR_ENDPOINT = "campaignmetadataaggregator";
export const TMS_CAMPAIGNMETADATAAGGREGATOR_PREFIX_EDOG = "https://messaging.engagement.office.com/";
export const TMS_CAMPAIGNMETADATAAGGREGATOR_PREFIX_PROD = "https://messaging.engagement.office.com/";

export const TMS_CAMPAIGN_LOAD_TIMEOUT = 3000;

export const TMS_FETCH_TIMEOUT = 5000; // timeout for fetching tms service requests

export const TMS_SETCAMPAIGNACTION_ENDPOINT = "setcampaignaction";
export const TMS_SETCAMPAIGNACTION_PREFIX_EDOG = "https://messaging.action.office.com/";
export const TMS_SETCAMPAIGNACTION_PREFIX_PROD = "https://messaging.action.office.com/";

export const TULIPS_SERVICEURL =
	"https://substrate.office.com/OfficePersonalizationUserLifecycle/api/facts";

export const TULIPS_LOAD_TIMEOUT = 3000;

export const TULIPS_FETCH_TIMEOUT = 5000; // timeout for fetching tulips service requests

export const TULIPS_INGESTION_TIME = 24 * 60 * 60 * 1000; // Tulips ingestion time

export const AUGLOOP_INIT_CHECK_RETRY_TIMES = 5;

/**
 * Constant GUIDs
 */
export class GUIDs {
	public static TMSAppID = "4c4f550b-42b2-4a16-93f9-fdb9e01bb6ed";
	public static TULIPSSubstrateAppID = "05c88d91-956e-46b4-91b0-77a33cc21a4d";
}
